import * as LJS from "../../../lib/littlejs.esm";
import { tilesize } from '../../const/tiles.ts';
import Globals from "../../globals.ts";
/*
 * Traps are objects that hurt the player
 */
class Trap extends LJS.EngineObject {
    constructor(pos, tileIndex) {
        super(pos, LJS.vec2(1, 1), LJS.tile(tileIndex, tilesize));
        // Overridden by the child class to make the trap interactive
        this.state = "disabled";
        this.damage = 1;
        this.distance = 1.2;
        this.setCollision(true, true, false, true);
        this.mass = 0; // Not affected by gravity
    }
    // Default behavior : When the user is near, we damage him
    update() {
        const distance = this.pos.distance(Globals.player.pos);
        if (distance < this.distance) {
            Globals.player?.takeDamage(this.damage, this.pos.copy());
        }
    }
}
export default Trap;
